import { Router } from "@angular/router";
import { RouteInfoService } from "../../route-info.service";
import { WebApiClient } from "../../web-api-client.service";
import { Rx } from "../rx/rx";
import { WebApiService } from "../../web-api.service";
import { Injectable } from "@angular/core";
@Injectable({
  providedIn: 'root'
})

export class ChiReportApi {
  constructor(private webApiFactory: WebApiClient,
    private router: Router, private routeInfo: RouteInfoService) {
    this.chineseReportApi = this.webApiFactory.createChineseService('Report');
  }

  chineseReportApi: WebApiService;
  getChineseReceiptInfo(registerId: number): Promise<ChineseReceiptInfoDto> {
    return this.chineseReportApi.get('GetChineseReceiptInfo?registerId=' + registerId).toPromise<ChineseReceiptInfoDto>();
  }
}
export class ChineseReceiptInfoDto {
  Hrxes: ChineseHrx[]
}


export class ChineseHrx {
  RxClass: string;

  FreqQTY: number;

  Freq:string;

  Way : string;

  ChiRemark : string;

  HRxId: number;

  Rx: Rx;
  Days: number;

  DailyDose : number;
}
